import PackageRoom from './PackageRoom'
import { OfflineModeProvider } from './hooks/useOfflineMode'

const PackageRoomRoute = () => {
  return (
    <OfflineModeProvider>
      <PackageRoom />
    </OfflineModeProvider>
  )
}

export default PackageRoomRoute
